export enum ResourceStatus {
  WARNING = 'warning',
  LIFECYCLE = 'lifeCycle',
  ARCHIVED = 'archived',
  ACTIVE = 'active',
  INVALID = 'invalid',
}
